import { Action } from '@ngrx/store';
import { OrangeData } from '../models/orange-data.model';

export enum OrangeDataActionTypes {
  ORANGEDATA_QUERY = '[OrangeData] Query',
  ORANGEDATA_LOADED = '[OrangeData] Fetched',

  ORANGEDATA_ADDED = '[OrangeData] Added',
  ORANGEDATA_EDITED = '[OrangeData] Edited',
  ORANGEDATA_DELETED = '[OrangeData] Deleted',
  ORANGEDATA_SAVED = '[OrangeData] Saved',

  ORANGEDATA_ERROR = '[OrangeData] Error'
}

export class OrangeDataQuery implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_QUERY;
}

export class OrangeDataLoaded implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_LOADED;

  constructor(public payload: { orangedatas: OrangeData[] }) {}
}

export class OrangeDataAdded implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_ADDED;

  constructor(public payload: { orangedata: OrangeData }) {}
}

export class OrangeDataEdited implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_EDITED;

  constructor(public payload: { orangedata: OrangeData }) {}
}

export class OrangeDataSaved implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_SAVED;

  constructor(public payload: {orangedata: OrangeData}) {}
}

export class OrangeDataDeleted implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_DELETED;

  constructor(public payload: { orangedata: OrangeData }) {}
}

export class OrangeDataError implements Action {
  readonly type = OrangeDataActionTypes.ORANGEDATA_ERROR;

  constructor(public payload: { error: any }) {}
}

export type OrangeDataActions =
  | OrangeDataQuery
  | OrangeDataLoaded
  | OrangeDataAdded
  | OrangeDataEdited
  | OrangeDataSaved
  | OrangeDataDeleted
  | OrangeDataError;
